import {
  createContext,
  ReactElement,
  useContext,
  useState,
  useEffect,
} from 'react';
import { useTheme } from '@mui/material/styles';
import { useRouter } from 'next/router';
import Box from '@mui/material/Box';
import { LottieLoader } from 'src/components/LottieLoader';
export type PageLoadingContextType = {
  toggleLoadingOverlay: (show: boolean) => void;
};

const defaultState: PageLoadingContextType = {
  toggleLoadingOverlay: () => {
    /* */
  },
};

const PageLoadingContext = createContext(defaultState);

export function usePageLoadingContext() {
  return useContext(PageLoadingContext);
}

export type PageLoadingProviderProps = {
  children: ReactElement;
};

export function PageLoadingProvider({ children }: PageLoadingProviderProps) {
  const router = useRouter();

  const [isLoading, setIsLoading] = useState<boolean>();
  const theme = useTheme();

  useEffect(() => {
    const handleStart = (_url, { shallow }) => {
      shallow ? setIsLoading(false) : setIsLoading(true);
    };
    const handleComplete = () => {
      return setIsLoading(false);
    };

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  });

  return (
    <PageLoadingContext.Provider
      value={{
        toggleLoadingOverlay: (state: boolean) => {
          setIsLoading(state);
        },
      }}
    >
      <>
        {children}
        {!!isLoading && (
          <Box
            sx={{
              height: '100vh',
              width: '100vw',
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: theme.palette.background.elevation[1],
              borderRadius: '10px',
              zIndex: 9999,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <LottieLoader sx={{ height: '40px', width: '40px' }} />
          </Box>
        )}
      </>
    </PageLoadingContext.Provider>
  );
}
